export type ViewsData = {
  date: string;
  views: number;
};

export type InteractionData = {
  date: string;
  interactions: number;
};

export type ConversionData = {
  date: string;
  ratio: number;
  coefficient: number;
};

export const CONTENT_SYNC_ID = 'content';
